import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';
import './Auth.css';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await authService.register({ email, password, nickname });
      login(response.token, {
        user_id: response.user_id,
        nickname: response.nickname,
        email: response.email,
      });
      navigate('/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-form-section">
          <div className="auth-logo">
            <h1>CCH</h1>
            <span>Codenerdette Gaming Hub</span>
          </div>
          <h2>Get Started</h2>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="nickname">Nickname</label>
              <input
                type="text"
                id="nickname"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                required
                placeholder="Choose a nickname"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Create a password"
              />
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Creating account...' : 'Sign up'}
            </button>
          </form>
          <p className="auth-switch">
            Already have an account?{' '}
            <button onClick={() => navigate('/login')}>Login</button>
          </p>
        </div>
        <div className="auth-illustration-section">
          <div className="stars-bg"></div>
          <div className="auth-illustration-content">
            <h2>AI-Powered Ancestor's Legacy</h2>
            <p>
              Become a spirit guide from the past. Shape your descendant's fate
              through thrilling mysteries and life-altering missions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register; 